import React, { useEffect, useState } from 'react';
import qs from 'query-string';
//import $ from 'jquery';

import PontoVendaForm from './PontoVendaForm';
import api from '../../../services/api';

import loadingGif from '../../../img/loading-gif.gif';
import shopIcon from '../../../img/fi-sr-shop.svg';

import { ChartDonut } from '@patternfly/react-charts';
import { ChartThemeColor } from '@patternfly/react-charts';

import { UilEllipsisV } from '@iconscout/react-unicons';
/*
import {
	Checkbox,
	Select,
	SelectOption,
	SelectVariant,
} from '@patternfly/react-core';
*/

import Select from 'react-select';
import { Dropdown } from 'react-bootstrap';

function PontoVenda(props) {
	const [unidades, setUnidades] = useState([]);
	const [pontovendas, setPontovendas] = useState([]);
	const [contas, setContas] = useState([]);
	const [params, setParams] = useState({ apelido: '', uni: '' });
	const [modalVisibleNovo, setModalVisibleNovo] = useState(false);
	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	//const [ariaFocusMessage, setAriaFocusMessage] = useState('');



	const [uniOptions, setUniOptions] = useState([{ value: '', label: 'Todas' }]);

	// eslint-disable-next-line no-unused-vars
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	//const [isOpen, setIsOpen] = useState(false);

	//const [selected, setSelected] = useState(null);

	//const [ponto, setPonto] = useState();

	const [loading, setLoading] = useState(true);
	const [loadingContas, setLoadingContas] = useState(true);

	const [condicaoFilterPv, setcondicaoFilterPv] = useState(3);

	//const [loadingRemove, setLoadingRemove] = useState(false);

	const novaPontoVendaModal = React.createRef();

	useEffect(() => {
		const qsearch = props.location.search;

		let qparams = qs.parse(qsearch);
		if (!qparams || !qsearch) {
			qparams = {
				apelido: '',
				uni: '',
			};
		}

		getUnidades({});
		getContas({});
		getPontoVendas(qparams);
		//handleInput = handleInput.bind(this);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function handleInput(e) {
		var target = e.target;
		var name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		const p = { ...params };
		p[name] = value;
		setParams({ ...p });
	}

	function getUnidades(params) {
		//var self = this;
		setLoading(true);
		//setState({ loading: true });
		api
			.get('/admin/unidade/json')
			.then(({ data, status }) => {
				if (status === 200) {
					////console.log('unidades');
					////console.log(data);
					setUnidades(data.unidades);
					const newUni = data.unidades;
					const newUniOptions = [
						{
							value: '',
							label: 'Todas',
						},
					];
					for (let i = 0; i < newUni.length; i++) {
						newUniOptions.push({
							value: newUni[i].id,
							label: `${newUni[i].nome} #; ${newUni[i].conta.nome}`,
						});
					}
					setUniOptions(newUniOptions);

					setLoading(false);
					//////console.log('Unidade');
				}
			})
			.catch((error) => {
				if (error.response.status === 401){
					window.location.reload(false);
					
				}
				//////console.log(err);
			});
	}

	async function getContas(params = {}) {
		//var self = this;
		setLoadingContas(true);

		try {
			const { data, status } = await api.get('/admin/conta/json', params);
			if (status === 200) {
				////console.log('contas');
				////console.log(data);
				setContas(data.contas);
				//self.setState({ contas: data.contas });
				setLoadingContas(false);
				//////console.log('Conta');
			}
			
		} catch (error) {
			console.log(error)
			alert('Error' + error);

			if (error.response.status === 401) {
				window.location.reload();
			}
			setLoadingContas(false)
			
		}

	
	}

	async function getPontoVendasFilter() {
		const { apelido, uni } = params;
		setLoading(true);

		const response = await api.get(
			`/admin/pontovenda/json?apelido=${apelido}&unidade=${uni}`
		);

		//////console.log(response);
		////console.log('pv');
		////console.log(response.data);

		if (response.status === 200) {
			setPontovendas(response.data);
			//////console.log('pontovendasfilter');
			setLoading(false);
		}

		
	}

	function getPontoVendaAtivo() {
		if (pontovendas.length > 1 && !!!loading) {
			const x = pontovendas.filter((pv) => {
				return pv.status === 1;
			});
			return x.length;
		}

		return '---';
	}

	function getPontoVendaInativo() {
		if (pontovendas.length > 1 && !!!loading) {
			const x = pontovendas.filter((pv) => {
				return pv.status === 0;
			});
			return x.length;
		}

		return '---';
	}

	function removeItemPontoVenda(pv) {
		const p = [...pontovendas];
		let index = -1;
		for (let i = 0; i < p.length; i++) {
			if (p[i].id === pv.id) {
				index = i;
			}
		}

		if (index !== -1) {
			p.splice(index, 1);
		}

		setPontovendas([...p]);
	}

	function updatePontoVendas(pv) {
		//////console.log(pv);
		const p = [...pontovendas];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === pv.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			//////console.log(p[index]);
			p[index] = pv;
			//////console.log(p[index]);
		} else {
			p.push(pv);
		}

		setPontovendas([...p]);
	}

	async function getPontoVendas(params) {
		//var self = this;
		setLoading(true);
		//////console.log('inicioPontoVendas');

		const { data, status } = await api.get('/admin/pontovenda/json', params);
		if (status === 200) {
			setPontovendas(data);
			//console.log(data);
			//self.setState({ pontovendas: data });
			//////console.log('PontoVendas');
			setLoading(false);

			return data;
		}
	}

	function updatePonto(pontoId) {
		const p = [...pontovendas];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === pontoId) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			//////console.log(p[index]);
			p[index].unidade = null;
			//////console.log(p[index]);
		}
	}

	async function desvincular(pontovenda, setStateRemove) {
		if (!window.confirm('Deseja Realmente desvincular esse registro? ')) {
			return;
		}

		setStateRemove(true);

		try {
			const response = await api.get(
				`admin/pontovenda/${pontovenda.id}/desvincular`
			);
			//console.log(response);
			const { data, status } = response;

			if (data.errors) {
				var keys = Object.keys(data.errors);
				var msgs = '';
				for (var i = 0; i < keys.length; i++) {
					msgs += data.errors[keys[i]] + '\n';
				}
				setStateRemove(false);

				alert(msgs);
				return;
			}

			if (data.id && status === 200) {
				updatePonto(data.id);
				//removeItemPontoVenda(pontovenda);
			}

			setStateRemove(false);
		} catch (error) {
			if (error.response.status === 401){
				window.location.reload(false);
				
			}
			////console.log(error);
			setStateRemove(false);
		}

		///admin/pontovenda/{id}/desvincular
	}

	async function remove(pontovenda, setStateRemove) {
		if (!window.confirm('Deseja Realmente excluir esse registro? ')) {
			return;
		}

		setStateRemove(true);

		try {
			const response = await api.delete('/admin/pontovenda/' + pontovenda.id);
			////console.log(response);
			const { data, status } = response;

			if (data && status === 200) {
				removeItemPontoVenda(pontovenda);
			}

			setStateRemove(false);
		} catch (error) {
			if (error.response.status === 401){
				window.location.reload(false);
				
			}
			////console.log(error);
			setStateRemove(false);
		}

		//var self = this;
		/*$.ajax({
			url: '/admin/pontovenda/' + pontovenda.id,
			type: 'DELETE',
		})
			.then(function (data) {
				if (data == true) {
					getPontoVendas(params);
				}
			})
			.catch(//////console.log);*/
	}

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='PontoVenda row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Pontos de Venda
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							data-toggle='modal'
							data-target='#novaPontoVendaForm'
							onClick={() => {
								novaPontoVendaModal.current.resetForm();
								setModalVisibleNovo(true);
							}}>
							Novo Ponto de Venda
						</button>
					</div>
				</h2>
				<PontoVendaForm
					ref={novaPontoVendaModal}
					contas={contas}
					unidades={unidades}
					elementId='novaPontoVendaForm'
					callback={updatePontoVendas}
					modalVisible={modalVisibleNovo}
					setModalVisible={setModalVisibleNovo}
				/>
			</div>
			<div style={{ background: '#EBEBEB' }} className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div
						style={{ background: '#EBEBEB' }}
						className='card-body padding-0'>
						<div className='card-body background-color-white border-radius-10 shadow'>
							<form>
								<div className='row'>
									<div className='form-group col-md-4'>
										<label>Apelido</label>
										<input
											className='form-control input-sm'
											type='text'
											name='apelido'
											value={params?.apelido}
											onChange={handleInput}
										/>
									</div>
									<div className='form-group col-md-4'>
										<label>Unidade</label>
										{/*<Select
																					className='form-control input-sm'

											variant={SelectVariant.typeahead}
											typeAheadAriaLabel='Todos'
											onToggle={(isOpen) => {
												setIsOpen(isOpen);
											}}
											onSelect={(event, selection, isPlaceHolder) => {
												if (isPlaceHolder) {
													setSelected(null);
													setIsOpen(false);
												} else {
													setSelected(selection);
													setIsOpen(false);
													////console.log('Selected: ', selection);
												}
											}}
											onClear={() => {
												setSelected(null);
												setIsOpen(false);
											}}
											selections={selected}
											isOpen={isOpen}
											placeholderText='Todas'>
											<SelectOption value=''/>
											{unidades.map((unidade)=>(
												<SelectOption value={unidade.id}/>
											))}
											</Select>*/}
										{
											<Select
												style={{}}
												placeholder='Unidades...'
												aria-labelledby='aria-label'
												//className='form-control input-sm'
												onMenuOpen={() => {
													setIsMenuOpen(true);
												}}
												onMenuClose={() => {
													setIsMenuOpen(false);
												}}
												name='uni'
												//value={params.uni}
												onChange={(e) => {
													const p = { ...params };
													p.uni = e.value;
													setParams({ ...p });

													//handleInput
												}}
												options={uniOptions}>
												<option value=''>Todas</option>
												{unidades.map((unidade) => (
													<option value={unidade.id}>
														{unidade.nome} &#35;{unidade.conta.nome}
													</option>
												))}
											</Select>
										}

										{/*<select
											className='form-control input-sm'
											name='uni'
											value={params?.uni}
											onChange={handleInput}>
											<option value=''>Todas</option>
											{unidades.map((unidade) => (
												<option value={unidade.id}>
													{unidade.nome} &#35;{unidade.conta.nome}
												</option>
											))}
											</select>*/}
									</div>
									<div className='form-group col-md-4'>
										<br />
										<button
											onClick={(e) => {
												e.preventDefault();
												getPontoVendasFilter();
											}}
											className='mt-2 btn btn-block btn-primary'>
											Filtrar
										</button>
									</div>
								</div>
							</form>
						</div>

						<div
							style={{ margin: 0 }}
							className='card-body background-color-white border-radius-10 my-3 row shadow space-between'>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
								}}>
								<img
									style={{ width: 20, height: 20 }}
									src={shopIcon}
									alt='shop'
								/>
								<div style={{ width: 20 }} className='greenLine' />
								<p
									style={{
										fontSize: 30,
										fontFamily: 'Roboto',
										fontWeight: '500',

										paddingVertical: 5,
										color: '#7D9828',
										marginBottom: 0,

										//lineHeight: 39,
									}}
									className='dropdown-calendar-text'>
									{'Pontos de Venda'}
								</p>
							</div>
							<button
								onClick={(e) => {
									e.preventDefault();
									if (condicaoFilterPv === 2) {
										setcondicaoFilterPv(3);
									} else {
										setcondicaoFilterPv(2);
									}
								}}
								style={{
									borderRadius: 10,
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',

									paddingRight: 35,
									paddingLeft: 35,
									marginTop: -10,
									paddingTop: 10,
									marginBottom: -10,
									paddingBottom: 10,
									border: 0,
									background: condicaoFilterPv === 2 ? '#F6F6F8' : '#FFF',
								}}>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										margin: 0,
										height: 20,
										padding: 0,

										alignSelf: 'flex-start',
									}}>
									<div
										style={{
											backgroundColor: '#A8BA6F',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									{'Todas'}
								</p>
								<div style={{ width: 30 }} className='greenLine' />

								<p
									style={{
										fontSize: 30,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
										marginBottom: 0,
									}}
									className='dropdown-calendar-text'>
									{pontovendas.length > 1 && !!!loading
										? pontovendas.length
										: '---'}
								</p>
							</button>
							<button
								onClick={(e) => {
									e.preventDefault();
									if (condicaoFilterPv === 1) {
										setcondicaoFilterPv(3);
									} else {
										setcondicaoFilterPv(1);
									}
								}}
								style={{
									borderRadius: 10,
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',

									paddingRight: 35,
									paddingLeft: 35,
									marginTop: -10,
									paddingTop: 10,
									marginBottom: -10,
									paddingBottom: 10,
									border: 0,
									background: condicaoFilterPv === 1 ? '#F6F6F8' : '#FFF',
								}}>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										margin: 0,
										height: 20,
										padding: 0,

										alignSelf: 'flex-start',
									}}>
									<div
										style={{
											backgroundColor: '#D3DCB7',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									{'Ativas'}
								</p>
								<div style={{ width: 30 }} className='greenLine' />

								<p
									style={{
										fontSize: 30,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
										marginBottom: 0,
									}}
									className='dropdown-calendar-text'>
									{getPontoVendaAtivo()}
								</p>
							</button>
							<button
								onClick={(e) => {
									e.preventDefault();
									if (condicaoFilterPv === 0) {
										setcondicaoFilterPv(3);
									} else {
										setcondicaoFilterPv(0);
									}
								}}
								style={{
									borderRadius: 10,
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',

									paddingRight: 35,
									paddingLeft: 35,
									marginTop: -10,
									paddingTop: 10,
									marginBottom: -10,
									paddingBottom: 10,
									border: 0,
									background: condicaoFilterPv === 0 ? '#F6F6F8' : '#FFF',
								}}>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										margin: 0,
										height: 20,
										padding: 0,

										alignSelf: 'flex-start',
									}}>
									<div
										style={{
											backgroundColor: '#F0F3E7',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									{'Inativas'}
								</p>
								<div style={{ width: 30 }} className='greenLine' />

								<p
									style={{
										fontSize: 30,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
										marginBottom: 0,
									}}
									className='dropdown-calendar-text'>
									{getPontoVendaInativo()}
								</p>
							</button>
							{!!!loading ? (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										width: 60,
									}}>
									<ChartDonut
										ariaDesc='Proporção de vendas'
										ariaTitle='Donut Chart'
										//constrainToVisibleArea={true}
										data={[
											{ x: 'Ativas', y: getPontoVendaAtivo() || 0 },
											{ x: 'Inativas', y: getPontoVendaInativo() || 0 },
										]}
										colorScale={['#D3DCB7', '#F0F3E7']}
										innerRadius={20}
										height={60}
										width={60}
										subTitle=''
										title=''
										padding={0}
										themeColor={ChartThemeColor.multiOrdered}
										constrainToVisibleArea={true}
									/>
								</div>
							) : (
								<div style={{ width: 60 }} />
							)}
							{<div></div>}
						</div>

						<div className='card-body background-color-white border-radius-10 shadow'>
							<table className='table'>
								<thead>
									<tr>
										<th></th>
										<th>Apelido</th>
										<th>Conta</th>
										<th>Unidade</th>
										<th>Data do Token</th>
										<th></th>
									</tr>
								</thead>
								{loading || loadingContas ? (
									<tbody>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
									</tbody>
								) : (
									<tbody>
										{pontovendas.map((ponto) => {
											if (
												ponto.status === condicaoFilterPv ||
												condicaoFilterPv === 2 ||
												condicaoFilterPv === 3
											) {
												return (
													<Ponto
														ponto={ponto}
														remove={remove}
														contas={contas}
														unidades={unidades}
														updatePontoVendas={updatePontoVendas}
														desvincular={desvincular}
													/>
												);
											} else {
												return null;
											}
										})}
									</tbody>
								)}
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function Ponto(props) {
	const {
		ponto,
		remove,
		contas,
		unidades,
		updatePontoVendas,
		desvincular,
	} = props;

	const [loadingRemove, setLoadingRemove] = useState(false);

	////console.log(ponto);

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	return (
		<tr key={ponto.id}>
			<PontoVendaForm
				modalVisible={modalVisibleEdit}
				setModalVisible={setModalVisibleEdit}
				elementId={'form' + ponto?.id}
				item={ponto}
				contas={contas}
				unidades={unidades}
				callback={updatePontoVendas}
			/>
			<td className='text-center'>
				<span
					style={{ fontSize: '1.2em' }}
					className={(ponto.status === '1'||ponto.status===1) ? 'text-success' : 'text-danger'}
					title={(ponto.status === '1'||ponto.status===1) ? 'Ativo' : 'Desativado'}>
					&#x029BF;
				</span>
			</td>
			<td>{ponto.apelido}</td>
			<td>{ponto.conta ? ponto.conta.nome : ''}</td>
			<td>{ponto.unidade ? ponto.unidade.nome : ''}</td>
			<td>{ponto.dataToken}</td>
			<td>
				<div
					style={{ display: 'flex', alignItems: 'center' }}
					className='float-right'>
					<button
						onClick={(e) => {
							e.preventDefault();
							//setPonto(ponto);

							if (loadingRemove) return;

							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#form' + ponto.id}>
						Editar
					</button>

					{loadingRemove ? (
						<button
							//onClick={() => remove(ponto, setLoadingRemove)}
							className='btn btn-sm btn-danger'>
							<img className='loadingImg' src={loadingGif} alt='loading' />
						</button>
					) : (
						<Dropdown style={{ padding: 0 }}>
							<Dropdown.Toggle
								className='btn btn-sm btn-danger'
								style={{ color: 'transparent', fontSize: 0 }}>
								<UilEllipsisV color='#FFFFFF' size='1.3rem' />
							</Dropdown.Toggle>
							<Dropdown.Menu
								className='shadow'
								style={{
									background: '#F6F6F6',
									boxShadow: '#0000001A',
									borderWidth: 1,
									borderColor: '#EBEBEB',
									border: 'solid 1px #EBEBEB',
									padding: 10,
									display: 'flex',
									flexDirection: 'column',

									//transition: 'width 1s',
								}}>
								<Dropdown.Item
									onClick={(e) => {
										e.preventDefault();
										remove(ponto, setLoadingRemove);
										//handleRankingChange(rank);
									}}
									className={'Dropdown-menu-item'}
									style={{
										//background: '#FFFFFF',
										//color: '#7D9828',
										fontFamily: 'Roboto',
										fontSize: 16,
										marginBottom: 5,
										borderRadius: 8,
									}}>
									{'Remover'}
								</Dropdown.Item>
								{ponto.provider === 'STONE' ? (
									<Dropdown.Item
										onClick={(e) => {
											e.preventDefault();
											desvincular(ponto, setLoadingRemove);
											//handleRankingChange(rank);
										}}
										className={'Dropdown-menu-item'}
										style={{
											//background: '#FFFFFF',
											//color: '#7D9828',
											fontFamily: 'Roboto',
											fontSize: 16,
											marginBottom: 5,
											borderRadius: 8,
										}}>
										{'Desassociar'}
									</Dropdown.Item>
								) : null}
							</Dropdown.Menu>
						</Dropdown>
					)}
				</div>
			</td>
		</tr>
	);
}

export default PontoVenda;
